import { render, staticRenderFns } from "./AppIntroduce.vue?vue&type=template&id=6c1da96b&scoped=true&"
import script from "./AppIntroduce.vue?vue&type=script&lang=js&"
export * from "./AppIntroduce.vue?vue&type=script&lang=js&"
import style0 from "./AppIntroduce.vue?vue&type=style&index=0&id=6c1da96b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1da96b",
  null
  
)

export default component.exports